import { authHeaders, fetchWithAuthRetry, getApiUrl, parseApiError } from './common';

export type HeartbeatNotification = {
  id: string;
  type: string;
  title: string;
  body: string;
  url: string;
  entityId: string | null;
  status: string;
  createdAt: string;
};

export type HeartbeatDaemon = {
  id: string;
  lastSeenAt: string | null;
  pendingVersion: string | null;
};

export type HeartbeatData = {
  unreadNotificationCount: number;
  recentNotifications: HeartbeatNotification[];
  activeTriggerCount: number;
  activeTriggerIds: string[];
  daemons: HeartbeatDaemon[];
};

type HeartbeatEnvelope = {
  data: HeartbeatData;
};

export const fetchHeartbeat = async (token: string, projectId: string): Promise<HeartbeatData> => {
  const response = await fetchWithAuthRetry(`${getApiUrl()}/api/projects/${projectId}/heartbeat`, {
    cache: 'no-store',
    headers: authHeaders(token),
  });

  if (!response.ok) {
    throw await parseApiError(response, `Failed to fetch heartbeat: ${response.status}`);
  }

  const payload = (await response.json()) as HeartbeatEnvelope;
  return payload.data;
};
